import type { ReactNode } from 'react';

export const symbol_raw_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M803-77 94-784q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l708 707q9 9 9 21t-9 21q-9 9-21 9t-21-9Zm-84-414-35 126-66-66-36-140q-3-11 4.5-20t19.5-9q8 0 14.5 5t8.5 13l32 124 30-125q2-8 7.5-12.5T712-600h11q8 0 13.5 4t7.5 12l33 126 29-123q2-8 8.5-13.5T829-600q12 0 19.5 9.5T853-570l-47 192q-2 8-8.5 13t-14.5 5h-12q-8 0-15-5t-9-13l-28-113ZM355-391l40-148 39 39-8 31h39l48 48H412l-11 43q-2 8-8.5 13t-14.5 5q-12 0-19-9.5t-4-21.5Zm-235 7v-194q0-9 7-15.5t16-6.5h121q23 0 35.5 12.5T312-552v63q0 20-12 30.5T271-446l24 55q5 11-2 21t-19 10q-8 0-13.5-4t-8.5-11l-26-66h-58v57q0 10-7 17t-17 7q-10 0-17-7t-7-17Zm48-105h96v-63h-96v63Z"
		/>
	</svg>
);
